


































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { INote } from "@/models/notes";
import { IRoute } from "@/models/routes";
import { IContractProduct } from "@/models/contracts";
import { IClient } from "@/models/clients";

@Component
export default class UNote extends Vue {
  // Props

  @Prop({ default: null })
  public author!: string;

  @Prop({ default: null })
  public datetime!: string;

  @Prop({ default: null })
  public note!: INote["note"];

  @Prop({ default: null })
  public isPinned!: boolean;

  @Prop({ default: false })
  public showSkeletons!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: null })
  public contractProduct!: IContractProduct;

  @Prop({ default: null })
  public clientId!: IClient;

  @Prop({ default: null })
  public updatePinned!: Function | null;

  // Computed

  public get cProdName() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/name`](
      this.contractProduct
    );
  }

  public get cProdRoute() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/route`]({
      ...this.contractProduct,
      client_id: this.clientId
    })?.to as IRoute["to"];
  }
}
